var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e8eaed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.62-140q-26.66 0-45.64-18.98T100-204.62v-586.92l47 47 66-67 67 67 67-67 66 67 67-67 67 67 66-67 67 67 67-67 66 67 47-47v586.92q0 26.66-18.98 45.64T795.38-140H164.62Zm0-40H460v-280H140v255.38q0 10.77 6.92 17.7 6.93 6.92 17.7 6.92ZM500-180h295.38q10.77 0 17.7-6.92 6.92-6.93 6.92-17.7V-300H500v120Zm0-160h320v-120H500v120ZM140-500h680v-167.69H140V-500Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.cb0654e4a3dacbc7113c5dd60d332d24.svg";
export { ForwardRef as ReactComponent };